import React, {useEffect, useRef, useState} from "react";
import mqtt from 'mqtt';
import "./Chat.scss";
import {useHistory, useLocation} from "react-router";
import {HistoryData, NextData, NotifyChat, SendFile} from "./ChatServices";
import {CheckinData} from "../Scan/ScanServices";
import moment from "moment-jalaali";
import axios, { post } from 'axios';
import {ConvertToJalali} from "../StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {Setup} from "../../Services";
import toaster from "toasted-notes";
import {useParams} from "react-router-dom";
import {StoreData} from "../StoreDetail/StoreDetailServices";
import useWindowDimensions from "../../hooks/useWindowDimensions";

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Chat() {


    //hooks
    const location = useLocation();
    const history = useHistory();
    const inputFile = useRef(null);
    const { id } = useParams();

    //states
    const [cli,setCli] = useState(null);
    const [text,setText] = useState("");
    const [merchant,setMerchant] = useState({});
    const [connect,setConnect] = useState(null);
    const [messages,setMessages] = useState([]);
    const [first,setFirst] = useState(false);
    const [preview,setPreview] = useState(null);
    const [modal,setModal] = useState(false);
    const [uploadLadda,setUploadLadda] = useState(false);
    const [file,setFile] = useState(null);
    const [dim,setDim] = useState({width:300,height:300});
    const [caption,setCaption] = useState("");
    const [next,setNext] = useState([]);
    const [merchantDirect,set_merchantDirect] = useState({});

    // WebSocket connect url ---
    // const WebSocket_URL = 'wss://chat-stage.digimaall.com:443/mqtt'
    const WebSocket_URL = Setup.mqtt


    //Mocks
    const LastMessage = [
        {owner:false, type:'text',data:"sdfsd",uid:'563'},
        {owner:false, type:'text',data:"56546",uid:'564'},
        {owner:false, type:'text',data:"asdad",uid:'565'},
        {owner:false, type:'text',data:"ghr45",uid:'567'},
        {owner:false, type:'text',data:"dssdfs435",uid:'568'},
        {owner:false, type:'text',data:"ersdfsf",uid:'569'},
        {owner:false, type:'text',data:"sdfsd",uid:'563'},
        {owner:false, type:'text',data:"56546",uid:'564'},
        {owner:false, type:'text',data:"asdad",uid:'565'},
        {owner:false, type:'text',data:"ghr45",uid:'567'},
        {owner:false, type:'text',data:"dssdfs435",uid:'568'},
        {owner:false, type:'text',data:"ersdfsf",uid:'569'},
        {owner:false, type:'text',data:"sdfsd",uid:'563'},
        {owner:false, type:'text',data:"56546",uid:'564'},
        {owner:false, type:'text',data:"asdad",uid:'565'},
        {owner:false, type:'text',data:"ghr45",uid:'567'},
        {owner:false, type:'text',data:"dssdfs435",uid:'568'},
        {owner:false, type:'text',data:"ersdfsf",uid:'569'},
    ]




    //Func

    const getSenderUid=  () =>{
        let user = localStorage.getItem('user');
        if(user) {
            let parsed_user = JSON.parse(user);
            return parsed_user.uid;
        }else {
            const {merchant} = location.state;
            return merchant.uid;
        }
    }



    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        if(top===0){
            // console.log("top event",next);
            if(next){
                try{
                    let response = await NextData(next.split("?")[1]);
                    // console.log("Respo : ",response);

                    //flow
                    let nexti = DataNormalization(response);
                    setNext(response.data.next);
                    // let allMess = [...nexti,...messages];
                    setMessages(state => ([...nexti,...state ]))
                    // console.log("All message : ",allMess);
                    // setMessages(allMess);
                }catch (e) {
                    // console.log("Error : ",e);
                }
            }
        }
    }

    const DataNormalization = (Histories,merchant) =>{
        let roomFeed = [];
        setNext(Histories.data.next);
        Histories.data.results.forEach(item=>{
            let date = moment(item.arrived).format('jYYYY/jMM/jDD HH:mm');
            let parsedPay =item.payload
            roomFeed.push({
                owner:parsedPay.sender_uid===getSenderUid(),
                type:parsedPay.type,
                data:parsedPay.message,
                uid:parsedPay.msgid,
                file:parsedPay.file_data?parsedPay.file_data:{},
                date:date
            })
        })
        roomFeed.reverse();
        return roomFeed
    }

    //Get History
    const getHistory = async (merchant) => {
        let topic = merchant.topic;
        try {
            const Histories = await HistoryData(topic);
            let feed =  DataNormalization(Histories,merchant);
            setMessages(feed);
            if(Histories.data.results.length>6){
                window.scrollTo({
                    left: 0,
                    top: document.body.scrollHeight,
                    behavior: 'smooth'});
            }else {
                window.scrollTo({
                    left: 0,
                    top: 0
                });
            }
        } catch (e) {
            console.log(e)
        }
    }

    //Notify Chat
    const Notify = async (topic) => {
        try {
            await NotifyChat({topic});
        } catch (e) {
            console.log(e)
        }
    }


    const getMerchant = async() => {
        let merchantId = id.split(":")[2];
        console.log("BBBBBBBBBBBBBBBBBBBBBBBB :",merchantId)
        try {
            let response = await StoreData(merchantId);
            console.log("Merchantd : ",response)
            set_merchantDirect(response.data)
        } catch (e) {
            console.log(e)
        }
    }



    useEffect(()=>{
        try {
            getMerchant()
            let client = {}
            let user = localStorage.getItem('user');
            if(user){
                let parsed_user = JSON.parse(user);
                console.log("UserId : ",parsed_user.uid)
                client = mqtt.connect(WebSocket_URL,{
                    clientId:`PWA-${parsed_user.uid}`,
                    "keepalive": 15
                })
                // client.options.clientId = `PWA-${parsed_user.uid}`;
            }
            //const {merchant} = location.state;
            const merchant = {topic:id};

            getHistory(merchant);
            console.log("State : ",location.state)
            setCli(client);
            setMerchant(merchant);
            client.on('connect', ()=>{
                console.log('Connected to', WebSocket_URL)
                console.log("Connetion status : ",client.connected)
                setConnect('Connected to'+"_"+WebSocket_URL)
                client.subscribe(merchant.topic, (err) => {
                    console.log(err || 'Subscribe Success',merchant.topic)
                    if(err){
                        setConnect("Error : "+err.toString())
                    }else {
                        setConnect("Subscribe Success"+merchant.topic)
                    }
                })
            })

            client.on("disconnect",(e)=>{
                console.log("Disconnect : ",e)
            })
            client.on("reconnect",(e)=>{
                console.log("reconnect : ",e)
            })
            // handle message event
            client.on('message', (topic, message,gg) => {
                let mes = message.toString();
                console.log('Received form', topic, ':', mes);
                setConnect('Connected to'+"_"+topic)
                let parsed= JSON.parse(mes);
                if(parsed.sender_uid!==getSenderUid()){
                    console.log("Parsed",parsed)
                    setMessages(state => ([...state, {
                        owner:false,
                        type:convertMediaTypeReceive(parsed.type),
                        date: moment(new Date().getTime()).format('jYYYY/jMM/jDD HH:mm'),
                        file:parsed.file_data?parsed.file_data:{},
                        data:parsed.message,
                        uid:parsed.sender_uid}]));
                    console.log("Messages : ",messages)
                    window.scrollTo({
                        left: 0,
                        top: document.body.scrollHeight,
                        behavior: 'smooth'});
                }
            })



            return () => {
                client.end(true); // Mqtt Close Connection
            };
        }catch (e) {
            console.log(e)
        }
    },[])


    useEffect(()=>{
        //handle scroll arrived to Top
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[next])


    const attachment = () =>{
        inputFile.current.click();
    }

    const checkDim = (type,url) =>{

        if(type==="image/png" || type==="image/jpeg"){
            let img = new Image()
            img.src = url
            img.onload = () => {
                setDim({width:img.width,height:img.height})
            }
        }

        if(type==="video/mp4"){
            const video = document.createElement('video')
            video.addEventListener('loadedmetadata', event => {
                setDim({width:video.videoWidth,height:video.videoHeight})
            });
            video.src = url;
        }

    }

    const fileChange = async (e) => {
        const target_file = e.target.files[0];
        console.log("Target : ",target_file)
        if(target_file){
            const url = await readURL(target_file);
            console.log("URL : ",url)
            checkDim(target_file.type,url)
            setFile(target_file);
            setPreview(url);
            setModal(true)
        }
    }

    const fileUpload = async () =>{
        setUploadLadda(true);
        try{
            //start loading
            const formData = new FormData();
            formData.append('file', file);
            let fileType = '2';
            if(file.type==="image/png" || file.type==="image/jpeg"){fileType='4'}
            if(file.type==="audio/mpeg"){fileType='3'}
            if(file.type==="video/mp4"){fileType='1'}

            formData.append('type', fileType);
            const response = await SendFile(formData,id)
            setUploadLadda(false);
            //end loading
            console.log(response.data);
            //publish caption & file path & type
            sendMedia(response.data.file,response.data.type,caption)
            //close modal
            setModal(false);
        }catch (e) {
            //end loading
            console.log(e);
            setUploadLadda(false);
        }
    }

    const convertMediaTypeReceive = (type) =>{
        let result = "text";
        switch (type) {
            case -1 :
                result = "image";
                break;
            case 'image' :
                result = "image";
                break;
            case 'file' :
                result = "file";
                break;
            case 'video' :
                result = "video";
                break;
            case 'audio' :
                result = "audio";
                break;
        }
        return result;
    }


    const convertMediaType = (type) =>{
        let result = "image";
        switch (type) {
            case 0 :
                result = "file";
                break;
            case 1 :
                result = "video";
                break;
            case 2 :
                result = "file";
                break;
            case 3 :
                result = "audio";
                break;
            case 4 :
                result = "image";
                break;
        }
        return result;
    }

    // date: moment(new Date().getTime()).format('jYYYY/jMM/jDD HH:mm'),

    const sendMedia = (path,type,captoin) =>{
        cli.publish(
            id,
            JSON.stringify({
                message:captoin,
                type:convertMediaType(type),
                is_seen:false,
                file_data: {
                    file: path,
                    type: type,
                    width:dim.width,
                    height:dim.height
                },
                uid:getSenderUid()+"@"+new Date().getTime(),
                sender_uid:getSenderUid()
            }),
            {qos: 2},
            async (error) => {
                console.log(error || 'Publish Success');
                setConnect('Connected to'+"_publish");
                await setMessages([...messages,
                    {
                        owner:true,
                        type:convertMediaType(type),
                        data:captoin,
                        uid:getSenderUid(),
                        date: moment(new Date().getTime()).format('jYYYY/jMM/jDD HH:mm'),
                        file:{
                            file: path,
                            type: type,
                        }
                    }
                ])


                window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: 'smooth'});
                setText("");
                setCaption("");
                if(!first){
                    Notify(id);
                    setFirst(true);
                }
            })
    }



    // date: moment(new Date().getTime()).format('jYYYY/jMM/jDD HH:mm'),

    const sendMessage = () =>{
        console.log(text.length)
        if(text.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"پیام خالی می باشد"}/>),{duration: 2000});
            return false
        }

        cli.publish(
            id,
            JSON.stringify({
                message:text,
                type:'text',
                is_seen:false,
                uid:getSenderUid()+"@"+new Date().getTime(),
                sender_uid:getSenderUid()
            }),
            {
                qos: 2
            },
            async (error) => {
                console.log(error || 'Publish Success');
                setConnect('Connected to'+"_publish")
                await setMessages([...messages, {
                    owner:true,
                    type:'text',
                    date: moment(new Date().getTime()).format('jYYYY/jMM/jDD HH:mm'),
                    data:text,
                    uid:getSenderUid()}])
                console.log("Mess : ",messages)
                if(messages.length > 4)
                    window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: 'smooth'});

                setText("");
                if(!first){
                    Notify(id);
                    setFirst(true);
                }
            })
    }

    const onEnter = (event, callback) => event.key  === 'Enter' && callback();
    const enterEvent = () => sendMessage();

    const detectType= (file) =>{
        let fileType = "2";
        if(file.type==="image/png" || file.type==="image/jpeg"){fileType="4"}
        if(file.type==="audio/mpeg"){fileType="3"}
        if(file.type==="video/mp4"){fileType="1"}
        return fileType;
    }

    const readURL = file => {
        return new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = e => res(e.target.result);
            reader.onerror = e => rej(e);
            reader.readAsDataURL(file);
        });
    };

    const { height, width,mobileWidth } = useWindowDimensions();

    return(
        <div>

            <div className="chat-container"  >
                <input type='file' id='file' accept="*" onChange={fileChange} ref={inputFile} style={{display: 'none'}} />

                <Rodal customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'auto'}}
                       animation={"zoom"}  onClose={()=>setModal(false)} visible={modal} >
                    <div className="send-attachment-modal">
                        {file && detectType(file)==="0"?<img src={preview} alt=""/>:null}
                        {file && detectType(file)==="4"?<img src={preview} alt=""/>:null}
                        {file && detectType(file)==="1"?<video width="320" height="240" controls><source src={preview} type="video/mp4"/></video>:null}
                        {file && detectType(file)==="2"?<img style={{width:50}} src="/other/file.png" alt=""/>:null}
                        {file && detectType(file)==="3"?<audio controls><source src={preview} type="audio/mpeg"/></audio>:null}
                        <input type="text" name=""
                               value={caption}
                               onChange={(e)=>{setCaption(e.target.value)}}
                               id="" placeholder="متن پیام" />
                        {!uploadLadda?<div className="footer-sec">
                            <span onClick={()=>setModal(false)}>انصراف</span>
                            <span onClick={fileUpload}>
                                    ارسال
                                    </span>
                        </div>:<div className="footer-sec-preload">
                            <span>در حال ارسال </span>
                            <img src="/other/pr.gif" alt=""/>
                        </div>}
                    </div>
                </Rodal>
                {/*Header*/}
                <div className="chat_header" >
                    <span>{merchantDirect && merchantDirect.name}</span>
                    <i
                        onClick={()=>{
                            // history.push(`/store-detail/${id.split(":")[2]}`);
                            history.goBack()
                        }}
                        className="fa fa-arrow-right back_btn" ></i>
                </div>


                <div className="chat-body" id="chat-body">
                    {/*<div>{connect}</div>*/}
                    {/*<div>{merchant.topic}</div>*/}
                    {messages.map(message=>{
                        return(
                            <div className={message.owner?"message-owner-card":"message-merchant-card"}>
                                <div className="message-body">
                                    {message.type==="image"?<div className="chat-media-type">
                                        <img className="image-type-img" src={message.file.file} alt=""/>
                                        <span className="caption">{message.data}<br/>
                                            <span className="date" >{message.date}</span>
                                            </span>
                                    </div>:null}
                                    {message.type==="video"?<div className="chat-media-type">
                                        <video width="320" height="240" controls>
                                            <source src={message.file.file} type="video/mp4"/>
                                        </video>
                                        <span className="caption">{message.data}
                                            <br/>
                                            <span className="date">{message.date}</span>
                                            </span>
                                    </div>:null}
                                    {message.type==="file"?<div className="chat-media-type">
                                        <a href={message.file.file}>
                                            <img className="file-type-img" src="/other/file.png" alt=""/>
                                        </a>
                                        <span className="caption">{message.data}
                                            <br/>
                                            <span className="date">{message.date}</span>
                                            </span>
                                    </div>:null}
                                    {message.type==="audio"?<div className="chat-media-type">
                                        <audio controls>
                                            <source src={message.file.file} type="audio/mpeg"/>
                                        </audio>
                                        <span className="caption">{message.data}
                                            <br/>
                                            <span className="date">{message.date}</span>
                                            </span>
                                    </div>:null}
                                    {message.type==="text"?
                                        <div className="text-type-sec">
                                            <span className="message-text">{message.data}</span>
                                            <span className="message-text date">{message.date}</span>
                                        </div>
                                        :null}
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="chat-send-box" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                    <input
                        value={text}
                        onKeyPress={e => onEnter(e, enterEvent)}
                        onChange={(e)=>{setText(e.target.value)}}
                        placeholder="پیام" type="text" name="" id=""/>
                    <div className="send-btn" onClick={()=>sendMessage()}>
                        <img src="/other/send-icon.png" alt=""/>
                    </div>
                    <div className="send-btn attached" onClick={()=>attachment()}>
                        <img src="/other/attached-icon.png" alt=""/>
                    </div>
                </div>
            </div>

        </div>
    )
}

export {Chat}
